export const Policy = () => {
  return (
    <div className="max-w-[500px] border-t-[1px] border-t-structure-95 font-reg">
      <h3 className="text-m font-med">How we use your data</h3>
      <p className="text-s">
        Here's how we use your personal information and that of your company
        directors, beneficial owners or guarantors. (Please make them aware of
        this before you provide their information to us)
      </p>
      <ul className="text-s font-reg">
        <li>
          We'll share it with credit reference agencies to run soft credit and
          identity checks. This won't affect your (or their) personal credit
          scores (note: we may ask you to provide a personal guarantee, so we'll
          only conduct credit checks on you and any other guarantors)
        </li>
        <li>
          We'll share it with fraud prevention agencies if we do spot any fraud,
          you could be refused services, finance, or employment.
        </li>
        <li>We might record your calls with us.</li>
      </ul>
      <p className="text-s">
        If you'd like to find out more, check our{' '}
        <a
          className="text-primary-40"
          href="/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy policy.
        </a>
      </p>
      <p className="text-s">iwoca Ltd is the data controller.</p>
    </div>
  );
};
